'use client';
import {useEffect, useState} from 'react';
import useMainStore from '@/stores/main';
import MyPlusApi from '@/api/main/my-plus';
import {getLocalStorage, isLogin, setLocalStorage} from '@/utils/main';
import {useResizeWidth} from '@/components/main/common/hooks/useResizeWidth';
import MainSection from '@/components/main/MyPlus/MainSection';
import {FloatingGroup} from '@/components/main/MyPlus/common/FloatingGroup';
import {SELECTED_MODE} from '@/constants/main';

//선호/인기 mode 인지 확인 후, 값이없다면 로그인 여부에따라서 default 값 셋팅
const getInitialSelectedMode = () => {
  try {
    let mode = getLocalStorage('selectedMode', undefined);
    if (mode === undefined) {
      mode = 'prefer';
    }
    setLocalStorage('selectedMode', mode);

    return mode;
  } catch (error) {
    return 'popular';
  }
};

export const MyPlusMain = () => {
  const [selectedMode, setSelectedMode] = useState(getInitialSelectedMode());
  const [mainListInfo, setMainListInfo] = useState({});
  const [isSimplifyMode, setIsSimplifyMode] = useState(false);

  //정적 데이터 가져오는 api
  const getStaticBroadListMainInfo = async () => {
    try {
      const res = await MyPlusApi.getStaticBroadListMainInfo();
      if (res) {
        setMainListInfo(res);
        // -1  :간소화모드 OFF
        // 1 : 간소화모드 ON

        if (res.simplifymodeResult === 1) {
          setIsSimplifyMode(true);
        } else {
          setIsSimplifyMode(false);
        }
      }
    } catch (error) {
      setMainListInfo({});
    }
  };

  const {topLiveList, setTopLiveList} = useMainStore();

  const containerClass =
    isLogin() && selectedMode === SELECTED_MODE.PREFER ? '_prefer' : '_popular';
  //ResizeObserver 창 너비 감지
  useResizeWidth();

  const handleOnClickMode = (mode) => {
    setLocalStorage('selectedMode', mode);
    setSelectedMode(mode);
  };

  useEffect(() => {
    getStaticBroadListMainInfo();
  }, []);

  useEffect(() => {
    setTopLiveList({
      ...topLiveList,
      count: 0,
      list: [],
    });
    window.scrollTo(0, 0);
  }, [selectedMode]);

  return (
    <>
      <div id='container' className={containerClass}>
        <MainSection
          selectedMode={selectedMode}
          mainListInfo={mainListInfo}
          isSimplifyMode={isSimplifyMode}
        />
        {/* 하단 플로팅 버튼 */}
        <FloatingGroup
          selectedMode={selectedMode}
          handleOnClickMode={handleOnClickMode}
          mainListInfo={mainListInfo}
        />
      </div>
    </>
  );
};
